import { createContext, useContext, useEffect, useState } from "react";
import { fetchMe, getToken, clearToken, setToken, login as apiLogin } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  // null = checking, false = unauth, object = authed
  const [user, setUser] = useState(null);

  useEffect(() => {
    const t = getToken();
    if (!t) {
      setUser(false);
      return;
    }
    fetchMe()
      .then((u) => setUser(u))
      .catch(() => {
        clearToken();
        setUser(false);
      });
  }, []);

  const login = async (email, password) => {
    const data = await apiLogin(email, password);
    setToken(data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    clearToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
